import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import React from 'react'
import { Cycle as CycleEntity } from '../../entities/cycle/Cycle'

import messages from './SimpleCycle.messages'
import { FormattedMessage } from 'react-intl'
import isToday from 'date-fns/isToday'
import BadgeMui from '@mui/material/Badge'
import { formatDate, formatTime } from '../../utils/format-date'
import DateFormats from '../../constants/DateFormats'
import CycleModal from '../cycle-modal/CycleModal'

export interface IOwnProps {
    cycle: CycleEntity
    className?: string
}

export type IProps = IOwnProps

interface CycleHeaderStyledProps {
    cycle: CycleEntity
}

const CycleHeader = styled('div')<CycleHeaderStyledProps>(
    ({ theme, cycle }) => ({
        padding: 2,
        background: `linear-gradient(90deg,
    ${theme.palette.secondary.main} ${cycle.progress}%,
    #fff ${cycle.progress}%,
    #fff 100%)`,
        color: '#000',
    })
)

const CycleContainer = styled(Paper)({
    overflow: 'hidden',
    borderColor: '#797979',
    textAlign: 'center',
})

const PickupFromDate = styled('div')({
    fontSize: 13,
    marginBottom: 2,
})

const PickupFromTime = styled('div')({
    fontSize: 16,
})

const CycleBody = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    padding: 8,
    fontSize: 13,
    lineHeight: '17px',
}))

const Badge = styled(BadgeMui)({
    '.MuiBadge-badge': {
        top: 2,
        right: -4,
    },
})

interface ICycleWrapper {
    cycle: CycleEntity
    className?: string
}

const CycleWrapper: React.FC<ICycleWrapper> = (props) => {
    const { cycle, children, className } = props
    const [isCycleModalOpen, setIsCycleModalOpen] = React.useState(false)

    const handleClick = () => {
        setIsCycleModalOpen(true)
    }

    const handleCycleModalClose = () => {
        setIsCycleModalOpen(false)
    }

    if (cycle.isReady) {
        // TO DO: add N/A logic
        //
        return (
            <>
                <div className={className} onClick={handleClick}>
                    {children}
                </div>

                <CycleModal
                    onClose={handleCycleModalClose}
                    cycle={cycle}
                    open={isCycleModalOpen}
                />
            </>
        )
    }

    return <div className={className}>{children}</div>
}

const SimpleCycle: React.FC<IProps> = (props) => {
    const { cycle, className } = props

    const pickupFromDate = formatDate(
        cycle.pickupFrom,
        DateFormats.DAY_WITH_SHORT_MONTH
    )
    const pickupFromTime = formatTime(cycle.pickupFrom)

    const labelsAmount = (
        <FormattedMessage
            {...messages.labeledProductsInCycle}
            values={{
                labels: cycle.numberOfOrdersLabeled,
            }}
        />
    )

    // ILYA не уверен какой вариант правильный
    const isNotAvailable =
        !cycle.numberOfOrdersLabeled && !!cycle.numberOfCanceledProducts
    // !cycle.numberOfOpenOrders && !!cycle.numberOfCanceledProducts

    return (
        <CycleWrapper cycle={cycle} className={className}>
            <CycleContainer variant='outlined'>
                <CycleHeader cycle={cycle}>
                    <PickupFromDate>
                        {isToday(cycle.pickupFrom) ? (
                            <FormattedMessage
                                {...messages.today}
                                values={{
                                    date: pickupFromDate,
                                }}
                            />
                        ) : (
                            pickupFromDate
                        )}
                    </PickupFromDate>

                    <PickupFromTime>{pickupFromTime}</PickupFromTime>
                </CycleHeader>

                <CycleBody>
                    {isNotAvailable ? (
                        <div>N/A</div>
                    ) : (
                        <>
                            <div>
                                <Badge
                                    color='error'
                                    variant='dot'
                                    // IlyaTODO: вставить сюда cycle.numberOfOrdersLabeled если логика реддота связана только с количеством пролейбленых заказов
                                    badgeContent={
                                        cycle.numberOfCanceledProducts
                                    }
                                >
                                    {labelsAmount}
                                </Badge>
                            </div>

                            {cycle.numberOfOpenOrders ? (
                                <div>
                                    <FormattedMessage
                                        {...messages.openOrdersInCycle}
                                        values={{
                                            orders: cycle.numberOfOpenOrders,
                                        }}
                                    />
                                </div>
                            ) : null}
                        </>
                    )}
                </CycleBody>
            </CycleContainer>
        </CycleWrapper>
    )
}

export default SimpleCycle
